import { render, staticRenderFns } from "./SurgeRemotePlayer.vue?vue&type=template&id=4d4b819a&scoped=true&"
import script from "./SurgeRemotePlayer.vue?vue&type=script&lang=js&"
export * from "./SurgeRemotePlayer.vue?vue&type=script&lang=js&"
import style0 from "./SurgeRemotePlayer.vue?vue&type=style&index=0&id=4d4b819a&scoped=true&lang=css&"
import style1 from "./SurgeRemotePlayer.vue?vue&type=style&index=1&id=4d4b819a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b819a",
  null
  
)

export default component.exports